import { Component, Input } from '@angular/core';
import { cardBadgeStyles, CardBenefitsProps, cardBenefitsStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-card-benefits',
  templateUrl: './card-benefits.component.html',
})
export class CardBenefitsComponent {
  /**
   * CSS del componente
   */
  @Input() css: CardBenefitsProps['css'];
  /**
   * Título de la card
   */
  @Input() title: CardBenefitsProps['title'];
  /**
   * Descripción de la card
   */
  @Input() description: CardBenefitsProps['description'];
  /**
   * Texto en el footer del componente
   */
  @Input() footerText: CardBenefitsProps['footerText'];
  /**
   * Tarjetas en el footer del componente
   */
  @Input() cards: CardBenefitsProps['cards'];
  /**
   * Texto en el badge del componente
   */
  @Input() badge: CardBenefitsProps['badge'];

  /**
   * Ícono de marca del componente
   */
  _brand: CardBenefitsProps['brand'];

  @Input() get brand() {
    return this._brand;
  }

  set brand(value: CardBenefitsProps['brand']) {
    this._brand = typeof value == 'string' ? [value] : value;
  }

  /**
   * Ícono de marca del componente
   */
  _icon: CardBenefitsProps['icon'];

  @Input() get icon() {
    return this._icon;
  }

  set icon(value: CardBenefitsProps['icon']) {
    this._icon = typeof value == 'string' ? [value] : value;
  }

  public get cardBenefitsStyles(): string[] {
    return [
      cardBenefitsStyles({
        css: this.css,
      }).className,
    ];
  }

  public get cardBadgeStyles(): string[] {
    return [cardBadgeStyles().className];
  }
}
